// extracted by mini-css-extract-plugin
module.exports = {"block":"styles-module--block--e450ec","invitation":"styles-module--invitation--0aec14","button":"styles-module--button--f9f31c"};